import { currencyFormatter } from '$lib/helpers/stringFormatters';

function renewalFrequency(interval, intervalCount) {
  let intervalText;
  switch (true) {
    case intervalCount == 1:
      intervalText = `${interval.toLowerCase()}ly`;
      break;
    case intervalCount == 3 && interval == 'month':
      intervalText = `quarterly`;
      break;
    default:
      intervalText = `every ${intervalCount} ${interval.toLowerCase()}s`;
  }
  return intervalText;
}

export function billingSummaryText(checkoutData) {
  const billingStartDate = checkoutData?.billingStartDate;

  return `Billed ${renewalFrequency(checkoutData?.interval, checkoutData?.intervalCount)} starting ${billingStartDate}. Cancel anytime in app.`;
}

export function invoiceSummaryText(checkoutData) {
  const discountDurationInMonths = checkoutData?.discountDurationInMonths;
  const total = currencyFormatter(checkoutData?.total, checkoutData?.currency, true);
  const fullPrice = currencyFormatter(checkoutData?.fullPrice, checkoutData?.currency, true);
  let summaryText = `Billed ${total} ${renewalFrequency(checkoutData?.interval, checkoutData?.intervalCount)}`; // This format also covers forever discount.

  if (checkoutData?.onceDiscount === true) {
    const discountFrequency =
      checkoutData?.intervalCount == 1
        ? `${checkoutData?.interval.toLowerCase()}`
        : `${checkoutData?.intervalCount} ${checkoutData?.interval.toLowerCase()}s`;
    summaryText = `${total} for the first ${discountFrequency}, then billed ${fullPrice} ${renewalFrequency(checkoutData?.interval, checkoutData?.intervalCount)}`;
  } else if (checkoutData?.inDiscountPeriod && discountDurationInMonths) {
    summaryText = `${total} per month for ${discountDurationInMonths} month${discountDurationInMonths > 1 ? 's' : ''}, then billed ${fullPrice} ${renewalFrequency(checkoutData?.interval, checkoutData?.intervalCount)}`;
  }

  return summaryText;
}

export function periodicTotalDescription(checkoutData) {
  const intervalText = renewalFrequency(checkoutData?.interval, checkoutData?.intervalCount);

  //Handle 'Monthly', 'Quarterly', 'Yearly' total as well as non-named periods like 'Total every 4 months' etc.
  return intervalText.includes('every')
    ? `Total ${intervalText}`
    : `${intervalText.charAt(0).toUpperCase() + intervalText.slice(1)} total`;
}
